// TODO change this to a CDN URL when ready
__webpack_public_path__ = `${location.protocol}//${location.host}/`
